import React, { useEffect } from 'react';

const LoadingScreen = ({ onLoadComplete }) => {
  useEffect(() => {
    // Preload logo image for instant display
    const img = new Image();
    img.src = '/logos/logo-black.jpg';

    // Auto-dismiss after 2.5 seconds
    const timer = setTimeout(() => {
      if (onLoadComplete) {
        onLoadComplete();
      }
    }, 2500);

    return () => clearTimeout(timer);
  }, [onLoadComplete]);

  return (
    <div className="fixed inset-0 bg-black z-50 flex flex-col items-center justify-center overflow-hidden">
      {/* Compact splash, logo + wordmark with a small spinner below.
          Sized in rem so it stays modest on any phone and never fills the screen. */}
      <div className="flex flex-col items-center">
        <h1 className="text-lg sm:text-xl font-bold tracking-[0.4em] text-white uppercase mb-3 animate-fade-in">
          ATELIA.AI
        </h1>

        <img
          src="/logos/logo-black.jpg"
          alt="ATELIA"
          className="h-14 sm:h-16 w-auto object-contain animate-fade-in"
          style={{ filter: 'invert(1)' }}
        />

        <p className="text-white text-[10px] sm:text-xs font-normal tracking-[0.35em] uppercase animate-fade-in opacity-50 mt-3">
          See Beyond the Label
        </p>

        {/* Small spinner */}
        <svg
          className="animate-spin mt-8"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          style={{ animationDuration: '1s' }}
        >
          <circle
            cx="16"
            cy="16"
            r="14"
            stroke="white"
            strokeWidth="2"
            fill="none"
            strokeDasharray="88"
            strokeDashoffset="66"
            strokeLinecap="round"
            opacity="0.8"
          />
        </svg>
      </div>
    </div>
  );
};

export default LoadingScreen;
